import { Center, Loader, Stack } from '@mantine/core';
import type { FC } from 'react';

import { Logo } from '../Logo/Logo.tsx';

export const RouteLoadingFallback: FC = () => {
  return (
    <Center h="100dvh" w="100dvw">
      <Stack align="center" gap="xl">
        <Logo />
        <Loader color="dark" size="sm" type="dots" />
      </Stack>
    </Center>
  );
};
